var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.012,
    height: 29.857,
    viewBox: "0 0 38.012 29.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14356",
    "data-name": "Group 14356",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42569",
    "data-name": "Path 42569",
    d: "M19.5,14.146V7.914h-1v6.232H5.095v5.3h1v-4.3H18.5v4.232h1V15.146H31.907v3.891h1V14.146Z",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14359",
    "data-name": "Group 14359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42574",
    "data-name": "Path 42574",
    d: "M21.789,21.015A2.786,2.786,0,1,1,19,18.229a2.786,2.786,0,0,1,2.786,2.786",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42575",
    "data-name": "Path 42575",
    d: "M20.959,24.173a3.324,3.324,0,0,1-3.913,0,6.935,6.935,0,0,0-3.595,4.5c-.169.574.172,1.184.656,1.184h9.8c.481,0,.822-.613.653-1.19a6.935,6.935,0,0,0-3.595-4.5",
    fill: "#2e2e2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14358",
    "data-name": "Group 14358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42572",
    "data-name": "Path 42572",
    d: "M8.382,21.015A2.786,2.786,0,1,1,5.6,18.229a2.786,2.786,0,0,1,2.786,2.786",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42573",
    "data-name": "Path 42573",
    d: "M7.552,24.173a3.324,3.324,0,0,1-3.913,0,6.935,6.935,0,0,0-3.595,4.5c-.169.574.172,1.184.656,1.184h9.8c.481,0,.822-.613.653-1.19a6.935,6.935,0,0,0-3.595-4.5",
    fill: "#2e2e2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14357",
    "data-name": "Group 14357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42570",
    "data-name": "Path 42570",
    d: "M21.789,2.786A2.786,2.786,0,1,1,19,0a2.786,2.786,0,0,1,2.786,2.786",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42571",
    "data-name": "Path 42571",
    d: "M20.959,5.944a3.324,3.324,0,0,1-3.913,0,6.935,6.935,0,0,0-3.595,4.5c-.169.574.172,1.184.656,1.184h9.8c.481,0,.822-.613.653-1.19a6.935,6.935,0,0,0-3.595-4.5",
    fill: "#2e2e2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14360",
    "data-name": "Group 14360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42576",
    "data-name": "Path 42576",
    d: "M35.2,21.015a2.786,2.786,0,1,1-2.786-2.786A2.786,2.786,0,0,1,35.2,21.015",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42577",
    "data-name": "Path 42577",
    d: "M34.367,24.173a3.324,3.324,0,0,1-3.913,0,6.935,6.935,0,0,0-3.6,4.5c-.169.574.172,1.184.656,1.184h9.8c.481,0,.822-.613.653-1.19a6.935,6.935,0,0,0-3.595-4.5",
    fill: "#2e2e2d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.04c406941cbb39fe56ca55cb374f99d9.svg";
export { ForwardRef as ReactComponent };